// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 8 hooks for backend/petrol.

import { useBackend } from '../useBackend'

/** POST /api/petrol/approvePetrolRequest */
export function useApprovePetrolRequest<T = any>() {
  return useBackend<T>('petrol/approvePetrolRequest')
}

/** POST /api/petrol/cancelPetrolRequest */
export function useCancelPetrolRequest<T = any>() {
  return useBackend<T>('petrol/cancelPetrolRequest')
}

/** POST /api/petrol/createPetrolRequest */
export function useCreatePetrolRequest<T = any>() {
  return useBackend<T>('petrol/createPetrolRequest')
}

/** POST /api/petrol/declinePetrolRequest */
export function useDeclinePetrolRequest<T = any>() {
  return useBackend<T>('petrol/declinePetrolRequest')
}

/** POST /api/petrol/getPetrolProofUrl */
export function useGetPetrolProofUrl<T = any>() {
  return useBackend<T>('petrol/getPetrolProofUrl')
}

/** POST /api/petrol/getPetrolRequestOptions */
export function useGetPetrolRequestOptions<T = any>() {
  return useBackend<T>('petrol/getPetrolRequestOptions')
}

/** POST /api/petrol/getPetrolRequests */
export function useGetPetrolRequests<T = any>() {
  return useBackend<T>('petrol/getPetrolRequests')
}

/** POST /api/petrol/markPetrolRequestPaid */
export function useMarkPetrolRequestPaid<T = any>() {
  return useBackend<T>('petrol/markPetrolRequestPaid')
}
